import { makeAutoObservable } from "mobx";
import type { AuthorsApi } from "@/api/authors";
import { Resource } from "./Resource";

/** An author (upphovsman) with their podcasts, keyed by slug. */
export class AuthorStore {
    readonly resource: Resource<Author, string>;

    constructor(private readonly api: AuthorsApi) {
        this.resource = new Resource((slug) => this.api.bySlug(slug));

        makeAutoObservable<AuthorStore, "api">(this, { api: false, resource: false });
    }

    get author(): Author | null {
        return this.resource.data ?? null;
    }

    get podcasts(): Podcast[] {
        return this.author?.podcasts ?? [];
    }

    /** Loads the author unless it is already loaded or loading. Failures end up in `resource.error`. */
    load(slug: string) {
        return this.resource.load(slug);
    }
}
